import { BuildingGroupAsyncMultiValuedList } from '../../../BuildingGroup'
import { isUserTable } from '../../Table.utils'
import { ListCell } from '../ListCell'

function TableAsyncBuildingGroupListCell({
  List = BuildingGroupAsyncMultiValuedList,
  context,
  id,
  value,
  ...cellProps
}) {
  const apiParams = isUserTable(context)
    ? {
        exclude_id: value?.id,
        inhabitant: id,
      }
    : null

  const preparedValue = value
    ? [{ children: value.name }, ...Array.from({ length: value.count - 1 })]
    : null

  return (
    <ListCell
      {...cellProps}
      List={List}
      count={value?.count}
      listProps={{ apiParams }}
      value={preparedValue}
    />
  )
}

export default TableAsyncBuildingGroupListCell
